import { useContext } from 'react';

import { context } from 'src/modules/designStudio/providers/SavedDesignsProvider';

export const useDesigns = () => useContext(context);
